import {
  CONTRACT_TITLE,
  CONTRACT_LAST_UPDATED,
  CONTRACT_INTRO,
  CONTRACT_SECTIONS,
  CONTRACT_ACK,
} from "@/lib/contract";

export default function ContractText({ compact = false }) {
  return (
    <article className={`text-white/85 ${compact ? "text-[13px] leading-relaxed" : "text-sm leading-relaxed"}`}>
      <header className="mb-5">
        <h3 className="font-display text-lg md:text-xl font-bold text-white mb-1">{CONTRACT_TITLE}</h3>
        <div className="text-[10px] uppercase tracking-[0.2em] text-white/50">Last Updated: {CONTRACT_LAST_UPDATED}</div>
      </header>
      <p className="mb-6 text-white/75">{CONTRACT_INTRO}</p>

      {CONTRACT_SECTIONS.map((s) => (
        <section key={s.heading} className="mb-5">
          <h4 className="font-display text-[15px] font-semibold text-[#C9A24B] mb-3 uppercase tracking-wider">
            {s.heading}
          </h4>
          <ul className="space-y-2.5">
            {s.points.map(([term, def]) => (
              <li key={term} className="text-white/80">
                <span className="font-semibold text-white">{term}:</span>{" "}
                <span className="text-white/70">{def}</span>
              </li>
            ))}
          </ul>
        </section>
      ))}

      <section className="mt-6 pt-5 border-t border-white/10">
        <h4 className="font-display text-[15px] font-semibold text-[#C9A24B] mb-3 uppercase tracking-wider">
          Acknowledgment & Electronic Signature
        </h4>
        <p className="text-white/75">{CONTRACT_ACK}</p>
      </section>
    </article>
  );
}
